// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"848393da","404":"74b53eb1"}[chunkId] + ".chunk.js";
};